import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-i-user-access-contact',
    templateUrl: './i-user-access-contact.component.html',
    styleUrls: ['./i-user-access-contact.component.scss'],
    standalone: false
})
export class IUserAccessContactComponent {

     companyInfo!: FormGroup;
     companyBillingInfo!: FormGroup;
     billingIsSame:string = 'true';
     _emailIsDup:boolean = false;
     _emailTesting:boolean = false;
     _emailBillingTesting:boolean = false;
     _emailIsBillingDup:boolean = false;

     confirmPrimaryContactEmail?: string = '';
     confirmBillingContactEmail?: string = '';

     hasPrimaryContactEmailMismatchError: boolean = false;
     hasBillingContactEmailMismatchError: boolean = false;

     constructor(public generalService: GeneralService, public enrollmentService: EnrollmentService) {
          if(!this.enrollmentService.billingUser){
               this.enrollmentService.iniBillingUser();
          }
          this.billingIsSame = this.enrollmentService.billingUserSame ;
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     ngOnInit() {
          if(this.enrollmentService.powerUser!.email !== ""){
               this.confirmPrimaryContactEmail = this.enrollmentService.powerUser!.email;
          }
          if(this.enrollmentService.billingUser!.email !== ""){
               this.confirmBillingContactEmail = this.enrollmentService.billingUser!.email;
          }
          this.companyInfo = new FormGroup({
               firstName: new FormControl(this.enrollmentService.powerUser!.firstName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastName: new FormControl(this.enrollmentService.powerUser!.lastName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               email: new FormControl(this.enrollmentService.powerUser!.email, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               confirmEmail: new FormControl(this.confirmPrimaryContactEmail, [
                    Validators.maxLength(50),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               primaryPhoneNumber: new FormControl(this.enrollmentService.powerUser!.primaryPhoneNumber, [
                    Validators.required,
                    Validators.minLength(10),
                    Validators.maxLength(10),
               ]),
               faxNumber: new FormControl(this.enrollmentService.powerUser!.faxNumber, [
                    Validators.minLength(10)
               ])
          });

          this.companyBillingInfo = new FormGroup({
                    
               firstNameBilling: new FormControl(this.enrollmentService.billingUser!.firstName, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastNameBilling: new FormControl(this.enrollmentService.billingUser!.lastName, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(15000),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               emailBilling: new FormControl(this.enrollmentService.billingUser!.email, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               confirmEmailBilling: new FormControl(this.confirmBillingContactEmail, [
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               primaryPhoneNumberBilling: new FormControl(this.enrollmentService.billingUser!.primaryPhoneNumber, [
                    (this.billingIsSame !== 'true' ? Validators.required : Validators.nullValidator),      
                    Validators.minLength(10),
                    Validators.maxLength(10),
               ]),
               faxNumberBilling: new FormControl(this.enrollmentService.billingUser!.faxNumber, [
                    Validators.minLength(10)
               ])
          });

          setTimeout(() => this.scrollToTop(), 500);
     }
     
     get firstName() { return this.companyInfo!.get('firstName'); }
     get lastName() { return this.companyInfo!.get('lastName'); }
     get email() { return this.companyInfo!.get('email'); }
     get confirmEmail() { return this.companyInfo!.get('confirmEmail'); }
     get primaryPhoneNumber() { return this.companyInfo!.get('primaryPhoneNumber'); }
     get faxNumber() { return this.companyInfo!.get('faxNumber'); }

     get emailIsDup() {return this._emailIsDup;}
     get emailTesting(){return this._emailTesting; }

     
     get firstNameBilling() { return this.companyBillingInfo!.get('firstNameBilling'); }
     get lastNameBilling() { return this.companyBillingInfo!.get('lastNameBilling'); }
     get emailBilling() { return this.companyBillingInfo!.get('emailBilling'); }
     get confirmEmailBilling() { return this.companyBillingInfo!.get('confirmEmailBilling'); }
     get primaryPhoneNumberBilling() { return this.companyBillingInfo!.get('primaryPhoneNumberBilling'); }
     get faxNumberBilling() { return this.companyBillingInfo!.get('faxNumberBilling'); }

     get emailIsBillingDup() {return this._emailIsBillingDup;}
     get emailBillingTesting(){return this._emailBillingTesting;}



     testPrimaryEmail() {
          
          this._emailIsDup = false;
          if(this.companyInfo!.get('email')?.valid){     
               this._emailTesting = true;
               this.enrollmentService.testEmail(this.companyInfo!.get('email')?.value)
               .subscribe((v: any) => {{
                         if(v === 'true'){
                              this._emailIsDup = true;
                         }else{
                              this._emailIsDup = false;
                         }
                         this._emailTesting = false;
                    }}
               );
          }
 
     }

     testBillingEmail() {
          if(this.companyBillingInfo!.get('emailBilling')?.valid){
               this._emailIsBillingDup = false;
               if(this.companyInfo!.get('email')?.valid){
                    this._emailBillingTesting = true;
                    this.enrollmentService.testEmail(this.companyBillingInfo!.get('emailBilling')?.value)
                    .subscribe((v: any) => {{
                              if(v === 'true'){
                                   this._emailIsBillingDup = true;
                              }else{
                                   this._emailIsBillingDup = false;
                              }
                              this._emailBillingTesting = false;
                         }}
                    );
               }
          }
     }

 

     updateIsSame(val: string) {
          this.billingIsSame = val;
          if(this.billingIsSame === 'false'){
               this.enrollmentService.iniBillingUser();
               this.companyBillingInfo = new FormGroup({
                    
                    firstNameBilling: new FormControl(this.enrollmentService.billingUser!.firstName, [
                         Validators.required,
                         Validators.maxLength(50),
                         Validators.pattern(/^([a-zA-Z ']*)$/)
                    ]),
                    lastNameBilling: new FormControl(this.enrollmentService.billingUser!.lastName, [
                         Validators.required,
                         Validators.maxLength(50),
                         Validators.pattern(/^([a-zA-Z ']*)$/)
                    ]),
                    emailBilling: new FormControl(this.enrollmentService.billingUser!.email, [
                         Validators.required,
                         Validators.maxLength(100),
                         Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
                    ]),
                    confirmEmailBilling: new FormControl(this.confirmBillingContactEmail, [
                         Validators.required,
                         Validators.maxLength(100),
                         Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
                    ]),
                    primaryPhoneNumberBilling: new FormControl(this.enrollmentService.billingUser!.primaryPhoneNumber, [
                         Validators.required,      
                         Validators.minLength(10),
                         Validators.maxLength(10),
                    ]),
                    faxNumberBilling: new FormControl(this.enrollmentService.billingUser!.faxNumber, [
                         Validators.minLength(10),
                    ])
               });
          }
     }

     getTranslator(val: string): string {
          let translation: string = this.generalService.getTranslation(val,'base');
          if (translation === undefined) {
              translation = this.generalService.getTranslation(val,'base');
          }
          return translation;
      }

     pageValid(){
          if(this._emailBillingTesting || this._emailTesting ){return 'true'};
          if(this.companyInfo.valid && this.email!.value !== this.confirmEmail!.value){return 'true'};
          if(this._emailIsDup === true || this._emailIsBillingDup === true){return 'true'};
          if(this.billingIsSame === 'false' && (this.companyBillingInfo.valid && (this.emailBilling!.value !== this.confirmEmailBilling!.value))){return 'true'};
          if(this.billingIsSame === 'false' && (this.companyBillingInfo.valid && (this.emailBilling!.value === this.email!.value))){return 'true'};
          if(this.billingIsSame === 'false' && !this.companyBillingInfo.valid){return 'true'};
          return (this.companyInfo.valid  ? null : 'true');
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngAfterViewInit() {
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }


     ngOnDestroy() {
          this.enrollmentService.billingUserSame = this.billingIsSame;
          this.enrollmentService.powerUser!.firstName = this.companyInfo!.get('firstName')?.value;
          this.enrollmentService.powerUser!.lastName = this.companyInfo!.get('lastName')?.value;
          this.enrollmentService.powerUser!.email = this.companyInfo!.get('email')?.value;
          this.enrollmentService.powerUser!.primaryPhoneNumber = this.companyInfo!.get('primaryPhoneNumber')?.value;
          this.enrollmentService.powerUser!.faxNumber = this.companyInfo!.get('faxNumber')?.value;
          if(this.billingIsSame === 'false'){
               this.enrollmentService.billingUser!.firstName  = this.companyBillingInfo!.get('firstNameBilling')?.value;
               this.enrollmentService.billingUser!.lastName = this.companyBillingInfo!.get('lastNameBilling')?.value;
               this.enrollmentService.billingUser!.email = this.companyBillingInfo!.get('emailBilling')?.value;
               this.enrollmentService.billingUser!.primaryPhoneNumber = this.companyBillingInfo!.get('primaryPhoneNumberBilling')?.value;
               this.enrollmentService.billingUser!.faxNumber = this.companyBillingInfo!.get('faxNumberBilling')?.value;
          }
          this.enrollmentService.saveToLocal();
     }

}
